import { useEffect } from 'react';

import { Container, Flex } from '@grupoboticario/flora-react';
import slugify from 'slugify';

import { PageInfo, Skeleton, ResponsiveFloraTypography } from 'components';
import { PrismicComponents } from 'containers';
import { newRelicMonitoringService } from 'services';

import Styles from './ContentBuilder.styles';
import { useContentBuilder } from './hooks';

export const ContentBuilder = () => {
  const { data, path, isLoading, isSuccess, shouldShowContent } = useContentBuilder();

  useEffect(() => {
    if (!shouldShowContent && !isLoading) {
      return window.location.replace('/');
    }
  }, [shouldShowContent, isLoading]);

  useEffect(() => {
    if (!isLoading) {
      newRelicMonitoringService.addPageAction(
        `pageview_${slugify(path ?? '', { lower: true, replacement: '_' })}`,
        {
          cd_detail: `${isSuccess ? 'sucesso' : 'erro'}`,
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess]);

  return (
    <Styles.Wrapper direction='column'>
      <Container>
        <PageInfo
          breadcrumbs={[
            {
              text: data.options?.title ?? 'material',
              url: '',
            },
          ]}
        >
          {isLoading ? (
            <>
              <Skeleton height='$12' width='25%' />
              <Skeleton height='$7' width='50%' />
            </>
          ) : (
            <Flex direction='column' gap='$2'>
              <ResponsiveFloraTypography fontSize='title' fontWeight='bold' as='h1'>
                {data.options?.title}
              </ResponsiveFloraTypography>

              <ResponsiveFloraTypography>{data.options?.description}</ResponsiveFloraTypography>
            </Flex>
          )}
        </PageInfo>
      </Container>

      <Styles.SectionWrapper>
        {isLoading ? (
          <Styles.SkeletonWrapper>
            <Container size='large'>
              <Flex direction='column' gap='$10'>
                <Skeleton height='$23' width='100%' data-testid='skeleton-component' />

                <Skeleton height='$16' width='50%' data-testid='skeleton-component' />

                <Flex gap='$4'>
                  <Skeleton height='$7' width='25%' data-testid='skeleton-component' />
                  <Skeleton height='$7' width='25%' data-testid='skeleton-component' />
                  <Skeleton height='$7' width='25%' data-testid='skeleton-component' />
                </Flex>

                <Flex gap='$4'>
                  <Skeleton height='$20' width='25%' data-testid='skeleton-component' />
                  <Skeleton height='$20' width='25%' data-testid='skeleton-component' />
                  <Skeleton height='$20' width='25%' data-testid='skeleton-component' />
                  <Skeleton height='$20' width='25%' data-testid='skeleton-component' />
                </Flex>
              </Flex>
            </Container>
          </Styles.SkeletonWrapper>
        ) : (
          <PrismicComponents components={data.components || []} />
        )}
      </Styles.SectionWrapper>
    </Styles.Wrapper>
  );
};
